import { SelectFieldData, SelectRecordProperty } from '@indigohive/cogfy-types'
import { FieldCellProps } from '../FieldCell'
import { OptionChip, OptionChipColorName } from '../../../components'
import clsx from 'clsx'

export function SelectCell (props: FieldCellProps<SelectRecordProperty, SelectFieldData>) {
  const { field, property, textWrap } = props

  const multiple = field.data?.select?.multiple ?? false
  const options = field.data?.select?.options ?? []
  const optionsById = new Map(options.map(option => [option.id, option]))
  const values = (Array.isArray(property?.select?.value) ? property.select.value : []).filter(value => optionsById.has(value.id))
  const selected = values
    .map(v => optionsById.get(v.id))
    .filter(v => v !== undefined)

  return (
    <div
      className={clsx(
        'flex',
        'gap-2',
        'px-2',
        'py-1',
        'w-full',
        'whitespace-pre-wrap',
        'overflow-x-hidden',
        textWrap && 'flex-wrap'
      )}
    >
      {(multiple ? selected : selected?.slice(0, 1))?.map(option => (
        <OptionChip
          key={option.id}
          label={option.label}
          color={option.color as OptionChipColorName}
        />
      ))}
    </div>
  )
}
